var exports = {
  "modalBackdrop": "Modal.module__modalBackdrop___Wjc3Rj",
  "layer": "Modal.module__layer___Wjc3Rj",
  "backdropSlot": "Modal.module__backdropSlot___Wjc3Rj",
  "positionAbsoluteInsetZero": "Modal.module__positionAbsoluteInsetZero___Wjc3Rj",
  "backdropCentered": "Modal.module__backdropCentered___Wjc3Rj",
  "focusLock": "Modal.module__focusLock___Wjc3Rj",
  "surface": "Modal.module__surface___Wjc3Rj",
  "layerFullscreen": "Modal.module__layerFullscreen___Wjc3Rj",
  "layerFullscreenMobile": "Modal.module__layerFullscreenMobile___Wjc3Rj",
  "layerCentered": "Modal.module__layerCentered___Wjc3Rj",
  "root": "Modal.module__root___Wjc3Rj",
  "centeredOnMobile": "Modal.module__centeredOnMobile___Wjc3Rj",
  "rootAnimating": "Modal.module__rootAnimating___Wjc3Rj",
  "medium": "Modal.module__medium___Wjc3Rj",
  "small": "Modal.module__small___Wjc3Rj",
  "large": "Modal.module__large___Wjc3Rj",
  "xlarge": "Modal.module__xlarge___Wjc3Rj",
  "fullscreen": "Modal.module__fullscreen___Wjc3Rj",
  "slideInFromRight": "Modal.module__slideInFromRight___Wjc3Rj",
  "slideOutToRight": "Modal.module__slideOutToRight___Wjc3Rj",
  "mobileSlideIn": "Modal.module__mobileSlideIn___Wjc3Rj",
  "mobileSlideOut": "Modal.module__mobileSlideOut___Wjc3Rj",
  "layout": "Modal.module__layout___Wjc3Rj",
  "header": "Modal.module__header___Wjc3Rj",
  "light": "Modal.module__light___Wjc3Rj",
  "dark": "Modal.module__dark___Wjc3Rj",
  "footer": "Modal.module__footer___Wjc3Rj",
  "stretchButtons": "Modal.module__stretchButtons___Wjc3Rj",
  "headerInner": "Modal.module__headerInner___Wjc3Rj",
  "headerText": "Modal.module__headerText___Wjc3Rj",
  "content": "Modal.module__content___Wjc3Rj",
  "contentNoPadding": "Modal.module__contentNoPadding___Wjc3Rj",
  "screenReaderLabel": "Modal.module__screenReaderLabel___Wjc3Rj",
  "insetCloseButtonContainer": "Modal.module__insetCloseButtonContainer___Wjc3Rj",
  "insetCloseButton": "Modal.module__insetCloseButton___Wjc3Rj",
  "contentLayout": "Modal.module__contentLayout___Wjc3Rj",
  "description": "Modal.module__description___Wjc3Rj",
  "inputGroup": "Modal.module__inputGroup___Wjc3Rj",
  "formFooter": "Modal.module__formFooter___Wjc3Rj",
};

__webpack_require__.r(module.exports = exports);
